export default "__VITE_ASSET__Bx6p0OdD__"